import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { cookies } from 'shared/utils/cookie.js';

export const useCookieConsentBarEffects = () => {
  const [showCookieConsent, setShowCookieConsent] = useState(false);

  useEffect(() => {
    const cookieConsent = cookies.cookieConsent.get();
    if (!cookieConsent || cookieConsent !== 'true') {
      setShowCookieConsent(true);
    }
  }, []);

  const handleAcceptCookieConsent = useCallback(() => {
    cookies.cookieConsent.set('true', { expires: 365 });
    setShowCookieConsent(false);
  }, [setShowCookieConsent]);

  return [showCookieConsent, handleAcceptCookieConsent] as const;
};
